import { Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

export function PageHeader({
    title,
    description,
    actions,
}: {
    title: string;
    description?: string;
    actions?: ReactNode;
}) {
    return (
        <Group justify="space-between" align="flex-end" wrap="wrap" gap="md">
            <Stack gap={4}>
                <Title order={2}>{title}</Title>
                {description ? (
                    <Text size="sm" c="dimmed" maw={640}>
                        {description}
                    </Text>
                ) : null}
            </Stack>
            {actions ? <Group gap="sm">{actions}</Group> : null}
        </Group>
    );
}
